import { DrawerContainer } from '../components/DrawerContainer'

/**
 * The Home component is the root component of the application.
 * It renders a DrawerContainer which contains the navigation and the content of the app.
 * The DrawerContainer is given the theme property of the parent component as a prop.
 * 
 * @param {Object} props - The properties passed to the component.
 * @returns JSX.Element
 */
export const Home = (props: any) => {
 return <DrawerContainer theme={props.theme} />
}